<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <OrderDetailComponent :order="order"></OrderDetailComponent>
      </v-col>
      <v-col>
        <a v-if="terms" :href="terms" download target="_blank">
          <v-btn color="primary" block class="rounded-lg mb-8" elevation="2"
            >Download Terms and Conditions</v-btn
          >
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { computed, toRef } from 'vue';
import { ITeamDTO, OrderDTO, TeamDTO } from '@/dtos';
import OrderDetailComponent from '@/components/orders/OrderDetailComponent.vue';

interface Props {
  teamId: string;
  yearId: string;
  team: ITeamDTO;
}
const props = defineProps<Props>();

const team = toRef(props, 'team', new TeamDTO());

const terms = computed(() => {
  return team.value.teamCriteria[0]?.terms?.url ?? '';
});
const order = computed(() => {
  return new OrderDTO(team.value.teamCriteria[0]?.order);
});
/*
const checkInTeam = async () => {
  try {
    await teamCheckIn(teamId, yearId);
    isCheckedIn.value = true;
  } catch (error) {
    console.error('Error fetching team:', error);
  }
};
*/
</script>
